import { useEffect, useState } from 'react';
import customAxios, { customFormAxios } from '../../util/Api';
import authHeader from 'services/auth/jwt/auth-header';
import { useDispatch } from 'react-redux';
import { FETCH_ERROR, FETCH_START, FETCH_SUCCESS } from '../../constants/ActionTypes';
import { useToast } from 'context/tostifyContext';

const useDocs = taskId => {
  const [files, setFiles] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const dispatch = useDispatch();
  const { showToast } = useToast();

  const fetchDocs = async (id = taskId, isMounted = true) => {
    if (!id) return;

    try {
      setIsLoading(true);
      dispatch({ type: FETCH_START });

      const response = await customAxios.get(`/Ops/GetTasksDocs/${id}`, {
        headers: authHeader(),
      });

      console.log(id);

      if (response.status === 200 && Array.isArray(response.data)) {
        const blobResponses = await Promise.all(
          response.data.map(item =>
            customAxios.get(`/Ops/GetTasksFile/${item.id}`, {
              headers: authHeader(),
              responseType: 'blob',
            }),
          ),
        );

        const formattedFiles = blobResponses.map((fileRes, idx) => {
          const urlObj = URL.createObjectURL(fileRes.data);
          return {
            id: response.data[idx].id,
            documentName: response.data[idx].docName,
            type: fileRes.data.type,
            urlObj,
          };
        });

        if (isMounted) {
          setFiles(formattedFiles);
          dispatch({ type: FETCH_SUCCESS });
        }
      } else {
        if (isMounted) {
          setFiles([]);
          dispatch({ type: FETCH_SUCCESS });
        }
      }
    } catch (err) {
      console.error('Error fetching docs:', err);
      if (isMounted) dispatch({ type: FETCH_ERROR, payload: 'Network Error' });
    } finally {
      if (isMounted) setIsLoading(false);
    }
  };

  useEffect(() => {
    let isMounted = true;

    if (taskId) {
      fetchDocs(taskId, isMounted);
    }

    return () => {
      isMounted = false;
    };
  }, [taskId]);

  const handleFileChange = (key = 'file') => async fileArr => {
    const fileData = fileArr?.[0];
    if (!fileData || !taskId) return;
    console.log('fileArr', fileArr);
    const formData = new FormData();
    formData.append('taskId', taskId);
    formData.append('files', fileData);
    formData.append('docType', 'files');
    console.log('filedata', fileData);
    try {
      const response = await customFormAxios.post(`/Ops/AddTasksDocs`, formData, {
        headers: authHeader(),
      });

      if (response.status === 200) {
        showToast('File uploaded successfully', 'success');
        fetchDocs(taskId);
      }
    } catch (err) {
      console.error('Upload failed:', err);
      showToast('Something went wrong while uploading', 'error');
    }
    console.log('Uploading for taskId:', taskId);
    console.log('Uploading file:', fileData.name);
  };

  const handleDeleteFiles = async file => {
    if (!file?.id || !taskId) return;
    if (!window.confirm('Are you sure you want to delete this document?')) return;

    try {
      dispatch({ type: FETCH_START });

      const res = await customAxios.post(`/Ops/DeleteTasksDocs`, { id: file.id }, { headers: authHeader() });

      if (res.status === 200) {
        showToast('File deleted successfully', 'success');
        fetchDocs(taskId);
      }

      dispatch({ type: FETCH_SUCCESS });
    } catch (err) {
      console.error('Failed to delete file:', err);
      dispatch({ type: FETCH_ERROR, payload: 'Delete failed' });
    }
  };

  const viewFile = async file => {
    if (!file?.id) return;
    console.log('file', file);
    dispatch({ type: FETCH_START });

    try {
      const res = await customAxios.get(`/Ops/GetTasksFile/${file.id}`, {
        headers: authHeader(),
        responseType: 'blob',
        // params: { id: file.id },
      });

      const blobUrl = window.URL.createObjectURL(res.data);
      const a = document.createElement('a');
      a.href = blobUrl;
      a.download = file.documentName || 'document';
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(blobUrl);
      dispatch({ type: FETCH_SUCCESS });
    } catch (err) {
      console.error('Failed to view file:', err);
      dispatch({ type: FETCH_ERROR, payload: 'Could not open file' });
    }
  };

  return {
    files,
    isLoading,
    fetchDocs,
    handleFileChange,
    handleDeleteFiles,
    viewFile,
  };
};

export default useDocs;
